import React from 'react';
import { InputNumber as AntInputNumber, InputNumberProps } from 'antd';

import { PlaceholderAsLabel } from '~shared/ui/layout';

export const InputNumber: React.FC<InputNumberProps> = ({ size = 'large', ...props }) => {
  return (
    <PlaceholderAsLabel placeholder={props.placeholder} value={props.value}>
      <AntInputNumber size={size} {...props} />
    </PlaceholderAsLabel>
  );
};
